import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ChangableComponent } from '@models/changable.component';
import { currencies, Currency, CurrencyEnum, User } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { takeUntil } from 'rxjs/operators';
import { i18nService as TranslateService } from '../../../i18n/translate.service';
import { AccountService, BillingService, ContextService, ScreenService } from '../../services';

@Component({
  selector: 'app-currency-selector',
  templateUrl: './currency-selector.component.html',
  styleUrls: ['./currency-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencySelectorComponent extends ChangableComponent implements OnInit {
  deviceService = inject(DeviceDetectorService);
  private accountService = inject(AccountService);
  private contextService = inject(ContextService);
  private billingService = inject(BillingService);
  private screenService = inject(ScreenService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private translate = inject(TranslateService);

  public currency: Partial<Currency> = {
    id: CurrencyEnum.usd,
    symbol: '$',
    formatString: '0,0.00',
    fraction: 2,
    title: 'USD',
  };
  public currencies: Currency[];
  public listOpened = false;
  public me: User;
  public isSmallScreen = this.screenService.isSmallScreen;

  ngOnInit() {
    this.currencies = [
      currencies[CurrencyEnum.usd],
      currencies[CurrencyEnum.eur],
      currencies[CurrencyEnum.rub],
      currencies[CurrencyEnum.try],
      currencies[CurrencyEnum.amd],
    ];

    this.contextService.me$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (me) => {
        if (!me) {
          return;
        }
        this.me = me;
        this.currency = currencies[me.currency_id];
        this.detectChanges();
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
      },
    });
  }

  public setCurrency(currency_id: CurrencyEnum) {
    this.closeList();
    this.updateAccountCurrency(currency_id);
  }

  public updateAccountCurrency(currency_id: CurrencyEnum) {
    if (currency_id === this.me.currency_id) {
      return;
    }

    this.accountService
      .updateAccount({ currency_id })
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (account) => {
          this.contextService.updateMe(account);
          this.billingService.setUser(account);

          this.accountService.hideCurrencyModal.next(true);
          const queryParams: Params = {
            currency: this.translate.directInstant(currencies[account.currency_id]?.title),
          };
          this.router
            .navigate([], {
              relativeTo: this.activatedRoute,
              queryParams,
              queryParamsHandling: 'merge',
            })
            .then();
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  public toggleList() {
    this.listOpened = !this.listOpened;
    this.detectChanges();
  }

  public closeList() {
    this.listOpened = false;
    this.detectChanges();
  }

  public trackByFn(index) {
    return index;
  }
}
